import { BillOrInvoiceRailz, TemporaryBillsOrInvoicesRails, withStyles } from 'vopay';
import styles from './ContactNameLink.module.scss';
import { getAspRowExtras } from './aspAccountingAdapter';

const cn = withStyles(styles);

type ContactNameLinkProps = {
  row: BillOrInvoiceRailz | TemporaryBillsOrInvoicesRails;
  // Opens the contact detail drawer. Absent where the drawer isn't available
  // (contact-scoped views) — the name renders as plain text.
  onOpenContact?: (clientAccountId: string) => void;
};

export default function ContactNameLink({ row, onOpenContact }: ContactNameLinkProps) {
  const name = row.Customer?.Name || row.customerRef?.name || row.vendorRef?.name || '';
  const clientAccountId = getAspRowExtras(row)?.AspClientAccountID;

  if (!clientAccountId || !onOpenContact) return <>{name}</>;

  return (
    <button type="button" className={cn('link')} onClick={() => onOpenContact(clientAccountId)}>
      {name}
    </button>
  );
}
